module.exports = __webpack_public_path__ + "static/media/history_4.37c4ca39.jpg";